import { NewsWidget } from '@/core/widgets/model/news-widget';
import { RouteObject } from 'react-router-dom';
import { convertWidgetToReactPath } from '@/core/widgets/router/convert-widget-to-react-path';
import ReactWidgetRouter from '@/core/widgets/router/react-widget-router';

const addSlashIfNeeded = (s: string) => {
  if (s.startsWith('/')) return s;

  return `/${s}`;
};

// Nested routes must stay relative to their parent: react-router rejects an
// absolute child path that doesn't start with the parent's full path.
const toRelativeRoutes = (routes?: RouteObject[]): RouteObject[] | undefined =>
  routes?.map(
    route =>
      ({
        ...route,
        path: route.path?.replace(/^\/+/, ''),
        children: toRelativeRoutes(route.children),
      }) as RouteObject,
  );

export function convertWidgetToReactRoute(widget: NewsWidget): RouteObject[] {
  return [
    {
      path: addSlashIfNeeded(widget.id),
      element: (
        <div className={'p-2 vh-100'}>
          <ReactWidgetRouter widget={widget} />
        </div>
      ),
      children: widget.routes.map(value => {
        return {
          ...value,
          path: addSlashIfNeeded(convertWidgetToReactPath(widget.id, value.path)),
          children: toRelativeRoutes(value.children),
        } as RouteObject;
      }),
    },
  ];
}
